import { css } from '@emotion/react';
import { BaseEmoji } from 'emoji-mart';
import { observer } from 'mobx-react-lite';
import { ReactElement, useEffect, useRef } from 'react';
import { IS_IE } from 'sdk';

import { useSDK } from '../../../../../app';
import { styled } from '../../../../../styled';
import { isMobile } from '../../../../../utils/isMobile';
import { SmileIcon } from '../messageFieldButtons/smileIcon';
import { EmojiPicker } from '.';

const Component = ({
	active,
	className,
	onEmojiPick,
	setShowEmoji,
}: {
	active: boolean;
	className: string;
	setShowEmoji?: (v: boolean) => void;
	onEmojiPick?: (v: BaseEmoji) => void;
}): ReactElement | null => {
	const wrapperRef = useRef<HTMLDivElement>(null);
	const { welcomeDataStore } = useSDK();
	const showEmoji = welcomeDataStore.data?.showcase?.useEmoji && setShowEmoji && !isMobile && !IS_IE;

	useEffect(() => {
		const fn = (): void => {
			setShowEmoji && setShowEmoji(false);
		};
		window.addEventListener('resize', fn);
		window.addEventListener('wheel', fn);
		return (): void => {
			window.removeEventListener('resize', fn);
			window.removeEventListener('wheel', fn);
		};
	}, [setShowEmoji]);

	if (showEmoji && onEmojiPick) {
		const onClick = (): void => {
			setShowEmoji(!active);
		};

		return (
			<div
				className={className}
				ref={wrapperRef}
				onMouseDown={(e): void => e.stopPropagation()}
				onWheel={(e): void => e.stopPropagation()}
			>
				<SmileIcon active={active} className="ncc-emoji" onClick={onClick} />
				<EmojiPicker
					isShow={active}
					position="fixed"
					onEmojiPick={onEmojiPick}
					wrapperTop={wrapperRef.current?.getBoundingClientRect().top || 0}
				/>
			</div>
		);
	} else return null;
};

export const EmojiPickerWrapper = styled(observer(Component))(
	css`
		position: relative;
		& > .ncc-emoji {
			cursor: pointer;
		}
	`
);
